import { ref, computed, onMounted } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { useToast } from '@/composables/common/useToast';
import { useQueryList as useListQuery } from '@/composables/common/useQueryList';

export function useEquiposIndex() {
    const toast = useToast();

    const list = useListQuery({
        fetcher: async params => {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.index'),
                params
            );
            return res.data || { data: [], meta: {} };
        },
    });

    const listaId = list.listaId;
    const hasEquiposAnterior = ref(false);

    const columns = computed(() => [
        { key: 'id', label: 'ID', class: 'tw:w-16' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'representante', label: 'Representante' },
        { key: 'imagen', label: 'Imagen', centered: true },
        { key: 'edad_media', label: 'Edad media', centered: true },
        { key: 'opciones', label: 'Opciones', centered: true }
    ]);

    async function borrar(equipoId) {
        const params = {
            lista_id: listaId.value,
            equipo_id: equipoId
        };

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.borrar'),
                params
            );
            toast.success(res.data.message);
            list.fetch();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error al borrar el equipo');
        }
    }

    async function checkAnterior() {
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.anterior'),
                { lista_id: listaId.value }
            );
            const data = res.data?.data || res.data || [];
            hasEquiposAnterior.value = data.length > 0;
        } catch (error) {
            hasEquiposAnterior.value = false;
            console.error('Error checking equipos anterior:', error);
        }
    }

    onMounted(() => {
        checkAnterior();
    });

    return {
        equipos: list.data,
        loading: list.loading,
        filters: list.filters,
        hasEquiposAnterior,
        listaId,
        columns,
        fetch: list.fetch,
        borrar,
    };
}
